// Swaps the header's hamburger icon for a close (X) icon while the mobile
// nav popover is open, and keeps it in sync no matter how the popover
// closes (toggle button, backdrop click, Escape key, or link tap). Also
// keeps aria-expanded and the accessible label accurate for screen readers.
function initMobileNavToggle(root) {
  const toggle = root.querySelector('[data-mobile-nav-toggle]');
  const nav = document.getElementById(toggle?.getAttribute('popovertarget'));
  if (!toggle || !nav || toggle.dataset.mobileNavReady) return;
  toggle.dataset.mobileNavReady = 'true';

  const openLabel = toggle.dataset.labelOpen;
  const closeLabel = toggle.dataset.labelClose;

  nav.addEventListener('toggle', (event) => {
    const isOpen = event.newState === 'open';
    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen && closeLabel) {
      toggle.setAttribute('aria-label', closeLabel);
    } else if (!isOpen && openLabel) {
      toggle.setAttribute('aria-label', openLabel);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initMobileNavToggle(document));
document.addEventListener('shopify:section:load', (event) => initMobileNavToggle(event.target));
